import { saveState, loadState } from '../../utils/localStorage';
export const initialState = loadState() || {
    user: {
        nombres: '',
        apellidos: '',
        email: '',
        telefono: '',
        tipoDocumentoId: '',
        numeroCedula: '',
        ciudadId: '',
        imagen: ''
    },
    authenticated: false,
    username: '',
    token: {
        access_token: "",
        expires_in: 0,
        refresh_expires_in: 0,
        refresh_token: "",
        token_type: "bearer",
        "not-before-policy": 0,
        session_state: "",
        scope: "",
    },
    infoToken: {},
    userInfo: {},
    permissions: [],
}

const sessionUserReducer = (state = initialState, action) => {
    if (action.type === "LOGIN_SESSION" || action.type === "LOGOUT") {
        saveState({
            ...state,
            token: action?.session, 
            infoToken: action?.infoToken,
            authenticated: action?.authenticated,
            username: action?.username,
            userInfo: action?.userInfo,
            permissions: action?.permissions,

        });
    }
    switch (action.type) {
        case "LOGIN_SESSION":
            return {
                ...state,
                token: action?.session, 
                infoToken: action?.infoToken,
                authenticated: action?.authenticated,
                username: action?.username,
                userInfo: action?.userInfo,
                permissions: action?.permissions,

            };
        case "LOGOUT":
            return {
                ...state,
                token: action.session,
                authenticated: action.authenticated,
                username: action.username
            };

        default:
            
            return state;
    }


};

export default sessionUserReducer;